import { timestamps, updatedBy } from '../interfaces/shared.interfaces';
import { CalendarRequest } from './calendarRequest';
import { Campaigns } from './campaigns.model';
import { Hospital } from './hospital.model';
import { Profile } from './profile.model';
import { Reason } from './reason.model';
import { ReasonMap } from './reasonMap.model';
import { Scenario } from './scenario.model';

export interface Calendar extends updatedBy, timestamps {
  _id?: string;
  date: Date;
  morningStartTime?: Date;
  morningEndTime?: Date;
  afternoonStartTime?: Date;
  afternoonEndTime?: Date;
  nightStartTime?: Date;
  nightEndTime?: Date;
  profile: Profile;
  hospital: Hospital;
  availability: string;
  requestOnHold?: CalendarRequest;
  fromCyle: boolean;
  fromCalendarsDataPipeline: boolean;
  description?: string;
  customDescription?: string;
  reason: Reason | string;
  isNight: boolean;
  campaignId?: Campaigns | string;
  reasonMap?: ReasonMap | string | null;
  keepCalendarAfterImport?: boolean;
  scenario?: Scenario;
}

export type DayCalendarsDto = {
  date?: string;
  dayCalendar?: Calendar;
  nightCalendar?: Calendar;
  haveCalendarInOtherHospitalsAtDay?: boolean;
  haveCalendarInOtherHospitalsAtNight?: boolean;
  campaigns?: Campaigns[];
};

export type ProfileCalendarsResponseDto = {
  calendars: DayCalendarsDto[];
  campaigns: Campaigns[];
};

type BasePutCalendars = Pick<
  Calendar,
  | '_id'
  | 'date'
  | 'hospital'
  | 'profile'
  | 'morningStartTime'
  | 'morningEndTime'
  | 'afternoonStartTime'
  | 'afternoonEndTime'
  | 'nightStartTime'
  | 'nightEndTime'
  | 'reasonMap'
  | 'reason'
  | 'customDescription'
  | 'keepCalendarAfterImport'
  | 'requestOnHold'
> & { hospital: string };
export interface PutCalendarsDto {
  createdCalendars: BasePutCalendars[];
  deletedCalendars: BasePutCalendars[];
}

export function postCalendars(calendars: Calendar[], isExtraclinique: boolean): any[] {
  const result = [];
  if (calendars) {
    for (const calendar of calendars) {
      const _calendar: any = {
        date: calendar.date,
        morningStartTime: calendar.morningStartTime,
        morningEndTime: calendar.morningEndTime,
        afternoonStartTime: calendar.afternoonStartTime,
        afternoonEndTime: calendar.afternoonEndTime,
        nightStartTime: calendar.nightStartTime,
        nightEndTime: calendar.nightEndTime,
        profile: calendar.profile._id,
        hospital: calendar.hospital._id,
        reason: calendar.reason,
        reasonMap: calendar.reasonMap,
        customDescription: calendar.customDescription,
        isExtra: isExtraclinique,
        keepCalendarAfterImport: calendar.keepCalendarAfterImport,
        scenario: calendar.scenario,
        campaignId: calendar.campaignId,
      };
      if (calendar._id) {
        _calendar._id = calendar._id;
      }
      result.push(_calendar);
    }
  }
  return result;
}

export function isGuard(calendar: Calendar | undefined) {
  return calendar &&
    calendar.reason &&
    (<Reason>calendar.reason).availability &&
    ((<Reason>calendar.reason).availability.match(/available/i) || calendar.availability === '') &&
    (<Reason>calendar.reason).isGarde
    ? true
    : false;
}

export function isAbsent(calendar: Calendar) {
  return (
    !calendar ||
    !calendar.reason ||
    (calendar.reason && (<Reason>calendar.reason).availability === '') ||
    (calendar && calendar.reason && (<Reason>calendar.reason).availability === 'ABSENT')
  );
}

export function isAvailable(calendar: Calendar) {
  return calendar && calendar.reason && (<Reason>calendar.reason).availability === 'AVAILABLE';
}
